import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'

const axios = getAxios()

export const processSlackMessage = async (requestData) => {
  if (!requestData || !requestData.message) {
    return false
  }

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/slackMessage', requestData)
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)
}
